import "primevue/resources/themes/lara-light-indigo/theme.css";
import "primeflex/primeflex.css";
import 'primeicons/primeicons.css';

import { createApp } from 'vue'
import App from './App.vue';

import PrimeVue from 'primevue/config';
// import ru from 'locales/primevue-ru.js'; // Импорт русского языка

import ToastService from 'primevue/toastservice';

// console.log("ru = ", ru);
const app = createApp(App);

app.provide('agreements', window.__APP_DATA__ || {});

// app.use(PrimeVue, {
//     locale: ru // Устанавливаем русскую локализацию
// });

app.use(PrimeVue, {
    locale: {
        dayNamesShort: ['Вс.', 'Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.'],
        dayNamesMin: ['Вс.', 'Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.'],
        monthNames: ["Янв.", "Фев.", "Мар.", "Апр.", "Май", "Июнь", "Июль", "Авг.", "Сен.", "Окт.", "Ноя.", "Дек." ],
        monthNamesShort: ["Янв.", "Фев.", "Мар.", "Апр.", "Май", "Июнь", "Июль", "Авг.", "Сен.", "Окт.", "Ноя.", "Дек." ],
        firstDayOfWeek: 1,
        dateFormat: "dd.mm.yy",
        invalidFileTypeMessage: 'Недопустимый тип файла. Разрешенные типы: {0}',
        invalidFileSizeMessage: 'Недопустимый размер файла. Максимальный размер: {0}',
    }
});
app.use(ToastService);
app.mount('#app');

